<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="pickups">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="pickups"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
        >
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="companyName" caption="Vendor" width="125"></dxi-column>
            <dxi-column caption="PO #" width="100" cellTemplate="poTemplate"></dxi-column>
            <dxi-column dataField="scheduledDate" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="numberOfSkids" width="100"></dxi-column>
            <dxi-column dataField="totalWeight" width="100"></dxi-column>
            <dxi-column dataField="instructions" width="250"></dxi-column>
            <dxi-column dataField="notes" width="250"></dxi-column>
            <dxi-column dataField="created" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="createdBy" width="100"></dxi-column>
            <dxi-column dataField="completed" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="completedBy" width="100"></dxi-column>
            <dxi-column dataField="linesHtml" caption="Lines" width="250" [encodeHtml]="false"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="vendor-search-grid"></dxo-state-storing>

            <div *dxTemplate="let cell of 'poTemplate'">
                <a *ngFor="let poNumber of cell.data.poNumbers" [routerLink]="[]" (click)="openPurchaseOrder(poNumber)">{{ poNumber || '' }} </a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button
                    class="btn btn-success ms-2"
                    (click)="complete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || showCompleted"
                >
                    Complete
                </button>
                <button
                    class="btn btn-sm btn-danger ms-3"
                    (click)="delete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || showCompleted"
                >
                    Delete
                </button>
                <button class="btn btn-sm btn-warning ms-3" (click)="toggleShowCompleted()">{{ showCompleted ? 'Show Active' : 'Show Completed' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="pickups" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items, ' + dataGrid.instance.getSelectedRowsData().length + ' selected' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
